<template>
  <div id="sidebar">
    <div class="sidebarbox">
      <ul>
     <!--   <li @click="showpoint" v-if="$store.userInfo">
          <div class="listbox">
            <img src="@/assets/sidebar/icon1.png" alt="" />
            <p>领点数</p>
          </div>
        </li> -->
        <li @click="status = true">
          <div class="listbox">
            <img src="@/assets/sidebar/icon2.png" alt="" />
            <p>反馈</p>
          </div>
        </li>
        <li>
          <el-popover placement="left-start" width="200" trigger="hover">
            <div class="popoverbox">
              <div>
                <img :src="website.web_kefu_use_qrcode" alt="" />
                <p>使用问题</p>
              </div>
              <div>
                <img :src="website.web_cooperation_qrcode" alt="" />
                <p>商务合作</p>
              </div>
            </div>
            <div slot="reference" class="listbox">
              <img src="@/assets/sidebar/icon3.png" alt="" />
              <p>客服</p>
            </div>
          </el-popover>
        </li>
      </ul>
    </div>
    <feedback v-if="status"></feedback>
  </div>
</template>

<script>
import feedback from "@/components/feedbacktc"
export default {
  components:{
    feedback
  },
  data() {
    return {
      status:false,
      website: this.$store.website,
    };
  },
  mounted() {
  },
  methods: {
    showpoint() {
      this.$emit("showpoint", true);
      this.$stopScroll();
    }
  },
};
</script>

<style lang="less">
.popoverbox {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #999;
  div:nth-child(1) {
    margin-bottom: 12px;
  }
  img {
    width: 120px;
  }
}
#sidebar {
  .sidebarbox {
    position: fixed;
    right: 32px;
    bottom: 36px;
    z-index: 3;
    li {
      .listbox {
        width: 56px;
        height: 56px;
        margin-bottom: 7px;
        background-color: #fff;
        border: 0.5px solid #e5e8ef;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        cursor: pointer;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #1d2129;
        img {
          width: 20px;
        }
      }
    }
    li:nth-child(1) {
      .listbox {
        color: #4b5690;
        background: linear-gradient(
          151deg,
          #e4e8ff -10.75%,
          #f7f5ff 43.79%,
          #fef1ff 112.62%
        );
        box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>